import React from 'react';
import { NavLink, Outlet } from 'react-router';
import { LayoutDashboard, Building2, Bot, Users, Package, RefreshCw, ChevronLeft, ChevronRight } from 'lucide-react';
import { UserMenu } from '@redbax/ui-kit';
import { cn } from '@redbax/ui-kit';

const adminNavItems = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/organizations', label: 'Organizations', icon: Building2 },
  { to: '/ai-services', label: 'AI Services', icon: Bot },
  { to: '/package-registries', label: 'Package Registries', icon: Package },
  { to: '/vulnerability-sync', label: 'Vuln Sync', icon: RefreshCw },
  { to: '/admins', label: 'Admins', icon: Users },
];

function AdminHeader() {
  return (
    <header className="flex h-14 items-center justify-between border-b border-border bg-surface px-4">
      <div className="flex items-center gap-2">
        <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-background border border-border">
          <svg width="20" height="14" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 2L24 6.5V17.5L16 22L8 17.5V6.5L16 2Z" stroke="#E5484D" strokeWidth="1.3" fill="#E5484D" />
            <path d="M10 7L4 4" stroke="#E5484D" strokeWidth="1" strokeLinecap="round" />
            <path d="M9 10L3 10" stroke="#E5484D" strokeWidth="1" strokeLinecap="round" />
            <path d="M9 14L3 14" stroke="#E5484D" strokeWidth="1" strokeLinecap="round" />
            <path d="M10 17L4 20" stroke="#E5484D" strokeWidth="1" strokeLinecap="round" />
            <path d="M22 7L28 4" stroke="#E5484D" strokeWidth="1" strokeLinecap="round" />
            <path d="M23 10L29 10" stroke="#E5484D" strokeWidth="1" strokeLinecap="round" />
            <path d="M23 14L29 14" stroke="#E5484D" strokeWidth="1" strokeLinecap="round" />
            <path d="M22 17L28 20" stroke="#E5484D" strokeWidth="1" strokeLinecap="round" />
            <path d="M16 8L20 10.5V15.5L16 18L12 15.5V10.5L16 8Z" fill="#0A0A0F" />
            <circle cx="16" cy="12" r="1.5" fill="#0A0A0F" />
          </svg>
        </span>
        <span className="text-lg font-bold text-text-primary">Redbax</span>
        <span className="ml-2 rounded bg-red-subtle px-2 py-0.5 text-xs font-semibold text-red-accent">
          ADMIN
        </span>
      </div>
      <div className="flex items-center gap-3">
        <UserMenu />
      </div>
    </header>
  );
}

function AdminSidebar() {
  const [collapsed, setCollapsed] = React.useState(false);

  return (
    <aside
      className={cn(
        'flex flex-col border-r border-border bg-surface transition-all duration-200',
        collapsed ? 'w-16' : 'w-56',
      )}
    >
      <nav className="flex-1 space-y-1 p-2 pt-4">
        {adminNavItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'border-l-2 border-red-accent bg-red-subtle/50 text-text-primary'
                  : 'text-text-secondary hover:bg-surface-raised hover:text-text-primary',
                collapsed && 'justify-center px-2',
              )
            }
          >
            <item.icon className="h-5 w-5 shrink-0" />
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-border p-2">
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="flex w-full items-center justify-center rounded-md p-2 text-text-secondary hover:bg-surface-raised hover:text-text-primary"
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {collapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
        </button>
      </div>
    </aside>
  );
}

export function AdminShell() {
  return (
    <div className="relative flex h-screen flex-col bg-background">
      <img
        src="/web.svg"
        alt=""
        aria-hidden="true"
        className="pointer-events-none fixed -left-5 -top-5 z-0 h-[700px] w-[700px] select-none opacity-[0.12]"
        style={{ maskImage: 'radial-gradient(circle at 0% 0%, black 25%, transparent 75%)', WebkitMaskImage: 'radial-gradient(circle at 0% 0%, black 25%, transparent 75%)' }}
      />
      <div className="relative z-10 flex h-screen flex-col">
        <AdminHeader />
        <div className="flex flex-1 overflow-hidden">
          <AdminSidebar />
          <main className="flex-1 overflow-y-auto p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
